module.exports = __webpack_public_path__ + "7e6c95b257da1c3fe029f0eddd90d436.svg";